const translations = {
    confirmationText: 'Import Customers',
    description:
        'This action will import your customers from QuickBooks® into your customer management list for use in AcreConnect',
    title: 'Sync Customers'
};

export default translations;
